export enum FrageHaeufigkeitAufwachen {
  EINMAL = 'einmal',

  ZWEIBISDREIMAL = 'zweibisdreimal',

  MEHRALSDREIMAL = 'mehralsdreimal',

  SPORADISCH = 'sporadisch',
}
